<template>
  <BQdtCard
    name="imexHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'ImportExportHelp',

  components: { BQdtCard },
}
</script>
